import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Utility } from '../shared/utility';
import { AuthService } from '../shared/services/auth/auth.service';
import { DBkeys } from '../shared/services/auth/db-keys';
import { ReadConfigService } from '../shared/services/common/read-config.service';
import { UserService } from '../shared/services/common/user.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-org-select',
  templateUrl: './org-select.component.html',
  styleUrls: ['./org-select.component.css']
})

export class OrgSelectComponent implements OnInit {
  dataLoading = true;
  orgOpened: boolean;
  message: any;
  public organizations: any;
  public events: string[] = [];
  public source: Array<string> = [];
  public data: any;
  public defaultOrg: any;
  multipleOrg = false;
  msg: any;
  private Claims: any;
  @Input() selectedOrg: any;
  @Output() orgValue = new EventEmitter();
  @Output() closeOrgDialog = new EventEmitter();
  @Output() singleOrg = new EventEmitter();
  @Input() public set manual(args) {
    if (args) {
      this.orgPopUp();
    }
  }

  constructor(
    private router: Router,
    private userService: UserService,
    private authService: AuthService,
    private readConfigService: ReadConfigService,
    private cdRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.loadOrganizations();
  }

  loadOrganizations() {
    this.dataLoading = true;
    const inputData = {
      userInfo: {
        encryptOrg: Utility.removeQuotes(sessionStorage.getItem(DBkeys.ENC_ORGID)),
        encryptUsr: Utility.removeQuotes(sessionStorage.getItem(DBkeys.ENC_USER))
      }
    };
    this.userService.getUserOrganizations(inputData)
      .subscribe(organizations => {
        if (organizations && organizations.length > 0) {
          this.data = [];
          organizations.filter((value: any) => {
            if (this.data.filter((x: any) => x.orgId === value.orgId).length !== 1) {
              this.data.push(value);
            }
            return this.data;
          });
          this.multipleOrg = this.data.length > 1;
          if (this.selectedOrg === undefined) {
            const currOrgId = this.authService.currentOrg;
            if (currOrgId === undefined || currOrgId === null) {
              this.defaultOrg = this.data[0];
            } else {
              const currOrg = this.data.filter((x: any) => x.orgId === currOrgId);
              this.defaultOrg = currOrg[0];
            }
            this.authService.saveCurrentOrg(this.defaultOrg.orgId);
            this.orgValue.emit(this.defaultOrg);
            this.authService.setCurrentOrgName(this.defaultOrg.orgName);
            this.selectedOrg = this.defaultOrg;
            if (!this.multipleOrg) {
              this.closeOrgDialog.emit();
            }
            this.singleOrg.emit(!this.multipleOrg);
          } else {
            this.defaultOrg = this.selectedOrg;
          }
          this.authService.saveCurrentOrg(this.defaultOrg.orgId);
          this.authService.allowChangeDDwn(true);
        }
        this.dataLoading = false;
      },
        (err: HttpErrorResponse) => {
          console.log(err);
          this.dataLoading = false;
        });
  }

  selectionChange(value: any): void {
    this.authService.saveCurrentOrg(value.orgId);
    this.authService.sendMessage(value.orgId);
    this.authService.getLoggedInUserInfo().subscribe(data => {
      if (data && data.values && data.values.encryptOrg) {
        this.authService.setEncCurrentOrg(data.values.encryptOrg);
        this.authService.processInitialResponse(data);
        this.authService.getDarkFeatureValue();
        this.authService.setCurrentOrgName(value.orgName);
        this.orgValue.emit(value);
        const paths = location.pathname.replace(/\//g, ',').split(',');
        if (paths.length > 1 && paths[1].toLowerCase() === 'home') {
          location.reload();
        } else {
          this.router.navigate(['/home']);
        }
        this.authService.loggedInChecker(true);
        setTimeout(() => {
          this.closeOrgDialog.emit();
        }, 300);
      }
    }, (err: HttpErrorResponse) => {
      console.log(err);
      this.closeOrgDialog.emit();
    });
  }

  close() {
    this.closeOrgDialog.emit();
    this.message = null;
  }

  orgPopUp() {
    const allowChange = sessionStorage.getItem(DBkeys.ALLOW_CHG);
    if (allowChange && allowChange === 'false') {
      // avoid user from changing organization when in edit mode
      this.message = this.readConfigService.getEditModeOrgSelect();
    } else {
      this.message = null;
    }
  }
}
